let env = {};

// env.baseURL = 'https://api.novo-sigap.ares-saude.com.br/api/v1/';
// env.normalURL = 'https://api.novo-sigap.ares-saude.com.br/';
// env.painelInatividade = 5;
// env.webserviceHost = 'websocket.novo-sigap.ares-saude.com.br';
// env.webservicePort = '';

//UPA ICARAI
// env.baseURL = 'https://api.6360890.it4d.com.br/api/v1/';
// env.normalURL = 'https://api.6360890.it4d.com.br/';
// env.webserviceHost = 'websocket.6360890.it4d.com.br';
// env.webservicePort = '';
// env.painelInatividade = 5;

//UPA UBS IV CENTENARIO
// env.baseURL = 'https://api.2787482.it4d.com.br/api/v1/';
// env.normalURL = 'https://api.2787482.it4d.com.br/';
// env.webserviceHost = 'websocket.2787482.it4d.com.br';
// env.webservicePort = '';
// env.painelInatividade = 5;

//UPA SAO MATEUS
// env.baseURL = 'https://api.6391869.it4d.com.br/api/v1/';
// env.normalURL = 'https://api.6391869.it4d.com.br/';
// env.webserviceHost = 'websocket.6391869.it4d.com.br';
// env.webservicePort = '';
// env.painelInatividade = 5;

//UPA Parque das Flores
// env.baseURL = 'https://api.4700449.it4d.com.br/api/v1/';
// env.normalURL = 'https://api.4700449.it4d.com.br/';
// env.webserviceHost = 'websocket.4700449.it4d.com.br';
// env.webservicePort = '';
// env.painelInatividade = 5;

//UPA Pirituba
// env.baseURL = 'https://api.6146341.it4d.com.br/api/v1/';
// env.normalURL = 'https://api.6146341.it4d.com.br/';
// env.webserviceHost = 'websocket.6146341.it4d.com.br';
// env.webservicePort = '';
// env.painelInatividade = 5;

//AMA UBS Jardim São Francisco II
// env.baseURL = 'https://api.2788527.it4d.com.br/api/v1/';
// env.normalURL = 'https://api.2788527.it4d.com.br/';
// env.webserviceHost = 'websocket.2788527.it4d.com.br';
// env.webservicePort = '';
// env.painelInatividade = 5;

//UBS Jardim Da Conquista II - FUNDAÇÃO ABC
// env.baseURL = 'https://api.3219771.it4d.com.br/api/v1/';
// env.normalURL = 'https://api.3219771.it4d.com.br/';
// env.webserviceHost = 'websocket.3219771.it4d.com.br';
// env.webservicePort = '';
// env.painelInatividade = 5;

//AMA Jardim Santo Andre
// env.baseURL = 'https://api.2787873.it4d.com.br/api/v1/';
// env.normalURL = 'https://api.2787873.it4d.com.br/';
// env.webserviceHost = 'websocket.2787873.it4d.com.br';
// env.webservicePort = '';
// env.painelInatividade = 5;

//UBS Parque Sao Rafael
// env.baseURL = 'https://api.4049853.it4d.com.br/api/v1/';
// env.normalURL = 'https://api.4049853.it4d.com.br/';
// env.webserviceHost = 'websocket.4049853.it4d.com.br';
// env.webservicePort = '';
// env.painelInatividade = 5;

//UBS RIO CLARO
// env.baseURL = 'https://api.4050061.it4d.com.br/api/v1/';
// env.normalURL = 'https://api.4050061.it4d.com.br/';
// env.webserviceHost = 'websocket.4050061.it4d.com.br';
// env.painelInatividade = 5;
// env.webservicePort = '';

//UBS CESARIO LANGE
// env.baseURL = 'https://api.2073757.it4d.com.br/api/v1/';
// env.normalURL = 'https://api.2073757.it4d.com.br/';
// env.webserviceHost = 'websocket.2073757.it4d.com.br';
// env.webservicePort = '';
// env.painelInatividade = 5;

//UBS CESARIO LANGE(DR MAURICIO)
// env.baseURL = 'https://api.7385110.it4d.com.br/api/v1/';
// env.normalURL = 'https://api.7385110.it4d.com.br/';
// env.webserviceHost = 'websocket.7385110.it4d.com.br';
// env.webservicePort = '';
// env.painelInatividade = 5;

//HOSPITAL CARDOSO FONTES
// env.baseURL = 'https://api.h-cardosofontes.it4d.com.br/api/v1/';
// env.normalURL = 'https://api.h-cardosofontes.it4d.com.br/';
// env.webserviceHost = 'websocket.h-cardosofontes.it4d.com.br';
// env.webservicePort = '';
// env.painelInatividade = 5;

//UBS I BAIRRO DOS TORNINOS CESARIO LANGE
// env.baseURL = 'https://api.203623.it4d.com.br/api/v1/';
// env.normalURL = 'https://api.203623.it4d.com.br/';
// env.webserviceHost = 'websocket.203623.it4d.com.br';
// env.webservicePort = '';
// env.painelInatividade = 5;

//POLICLINICA Dr Sebastião Vieira da Cruz Filho  
// env.baseURL = 'https://api.762210.it4d.com.br/api/v1/';
// env.normalURL = 'https://api.762210.it4d.com.br/';
// env.webserviceHost = 'websocket.762210.it4d.com.br';
// env.webservicePort = '';
// env.painelInatividade = 5;

//UBS IV LAZARO MENDES DE CASTANHO CESARIO LANGE
// env.baseURL = 'https://api.2065576.it4d.com.br/api/v1/';
// env.normalURL = 'https://api.2065576.it4d.com.br/';
// env.webserviceHost = 'websocket.2065576.it4d.com.br';
// env.webservicePort = '';
// env.painelInatividade = 5;

//CAPS RENASCER
// env.baseURL = 'https://api.634875.it4d.com.br/api/v1/';
// env.normalURL = 'https://api.634875.it4d.com.br/';
// env.webserviceHost = 'websocket.634875.it4d.com.br';
// env.webservicePort = '';
// env.painelInatividade = 5;

//CASA TEA CESARIO LANGE  - TEA
// env.baseURL = 'https://api.4820606.it4d.com.br/api/v1/';
// env.normalURL = 'https://api.4820606.it4d.com.br/';
// env.webserviceHost = 'websocket.4820606.it4d.com.br';
// env.webservicePort = '';
// env.painelInatividade = 5;

//UBS PARQUE BOA ESPERANCA
// env.baseURL = 'https://api.2788276.it4d.com.br/api/v1/';
// env.normalURL = 'https://api.2788276.it4d.com.br/';
// env.webserviceHost = 'websocket.2788276.it4d.com.br';
// env.webservicePort = '';
// env.painelInatividade = 5;

//UBS RECANTO VERDE DO SOL
// env.baseURL = 'https://api.2788489.it4d.com.br/api/v1/';
// env.normalURL = 'https://api.2788489.it4d.com.br/';
// env.webserviceHost = 'websocket.2788489.it4d.com.br';
// env.webservicePort = '';
// env.painelInatividade = 5;

//AMA UBS JARDIM TIETE I OSCAR PEREIRA DA SILVA
// env.baseURL = 'https://api.2787881.it4d.com.br/api/v1/';
// env.normalURL = 'https://api.2787881.it4d.com.br/';
// env.webserviceHost = 'websocket.2787881.it4d.com.br';
// env.webservicePort = '';
// env.painelInatividade = 5;

//UBS Jardim Nove de Julho
// env.baseURL = 'https://api.2788152.it4d.com.br/api/v1/';
// env.normalURL = 'https://api.2788152.it4d.com.br/';
// env.webserviceHost = 'websocket.2788152.it4d.com.br';
// env.webservicePort = '';
// env.painelInatividade = 5;

//env.baseURL = 'http://localhost:8889/api/v1/';
//env.normalURL = 'http://localhost:8889/';
//env.webserviceHost = 'localhost';
//env.webservicePort = '6001';
//env.painelInatividade = 5;
//env.mode = 'homolog';
//env.mode = 'production';
//env.mode = 'development';

env.baseURL = 'https://api.dev-sigap.it4d.com.br/api/v1/';
env.normalURL = 'https://api.dev-sigap.it4d.com.br/';
env.webserviceHost = 'websocket.dev-sigap.it4d.com.br';
env.webservicePort = '443';
env.pusherKey = '99999-key',
env.painelInatividade = 5;
env.mode = 'production';

//CCO LOCAL
// env.baseURL = 'http://10.10.0.30:84/api/v1/';
// env.normalURL = 'http://10.10.0.30:84/';
// env.webserviceHost = '10.10.0.30';
// env.webservicePort = '6001';

export default env